import { useEffect, useContext } from 'react';
import { Context } from 'context';
import { GROUP_UI_CONFIGS_UPDATED } from 'context/actions';
import { fetchGroupUiConfig } from 'Services/getApidataStrapi';

const useLoadGroupUiConfig = (groupId) => {
  const { state: { groupUiConfigs = {} }, dispatch } = useContext(Context);

  useEffect(() => {
    if (!groupId || groupUiConfigs[groupId] !== undefined) return;

    fetchGroupUiConfig(groupId).then((groupUiConfig) => {
      dispatch({
        type: GROUP_UI_CONFIGS_UPDATED,
        payload: { groupId, groupUiConfig },
      });
    });
    // groupUiConfigs intentionally omitted: it's a one-time guard to skip already-loaded groups;
    // including it would cause an infinite fetch loop after dispatch updates context.
    // dispatch is stable and does not need to be listed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);
};

export default useLoadGroupUiConfig;
